import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./useAuth";

export function AuthGuard() {
  const { isAuthenticated, isLoading, isProvisioningAccount, profileMissing, tenant } = useAuth();

  if (isLoading || isProvisioningAccount) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (profileMissing) {
    return <Navigate to="/no-workspace" replace />;
  }

  if (tenant?.status === "suspended") {
    return <Navigate to="/suspended" replace />;
  }

  return <Outlet />;
}
